export type DeadlineUrgency = "overdue" | "today" | "thisWeek" | "later";

const DAY_MS = 86400000;

/**
 * How loudly a deadline should read. A date already gone by on something still running is the
 * loudest of all; inside 24 hours is the last chance to act, and a week is roughly the horizon
 * within which a procurement or contract task still needs preparing.
 */
export const deadlineUrgency = (dueAt: string, now: number = Date.now()): DeadlineUrgency => {
  const msLeft = new Date(dueAt).getTime() - now;
  if (msLeft < 0) return "overdue";
  if (msLeft <= DAY_MS) return "today";
  if (msLeft <= 7 * DAY_MS) return "thisWeek";
  return "later";
};

export const URGENCY_COLOR: Record<DeadlineUrgency, string> = {
  overdue: "smError",
  today: "smError",
  thisWeek: "smChipAmberFg",
  later: "smMuted",
};
